module.exports = __webpack_public_path__ + "static/media/mail.92cb30ec.svg";